import { render } from "./CustomPopupMenuItem.vue?vue&type=template&id=46c791f7"
import script from "./CustomPopupMenuItem.vue?vue&type=script&lang=js"
export * from "./CustomPopupMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__